import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../../../hooks/remote/blogApi";
import { extractErrorMessage } from "../../../hooks/constants";
import { toast } from "react-toastify";

const BlogLoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const result = await authAPI.login({ email, password });

            if (result.success) {
                toast.success("Login successful!", { theme: "colored" });
                navigate("/blog-admin");
            } else {
                const errorMsg = result.message || "Login failed";
                setError(errorMsg);
                toast.error(errorMsg, { theme: "colored" });
            }
        } catch (err) {
            const errorMsg = extractErrorMessage(err);
            setError(errorMsg || "Network error. Please try again.");
            toast.error(errorMsg || "Network error. Please try again.", { theme: "colored" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#141D26] px-4">
            <div className="max-w-md w-full">
                <div className="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-8">
                    <h1 className="text-3xl font-bold text-center text-gray-800 dark:text-white mb-6">
                        Blog Admin Login
                    </h1>
                    <form onSubmit={handleLogin} className="space-y-4">
                        <div>
                            <label className="block text-gray-700 dark:text-gray-300 text-sm font-semibold mb-2">
                                Email
                            </label>
                            <input
                                type="email"
                                placeholder="admin@example.com"
                                className="w-full p-3 border border-gray-300 dark:border-gray-600 dark:bg-slate-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={loading}
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 dark:text-gray-300 text-sm font-semibold mb-2">
                                Password
                            </label>
                            <input
                                type="password"
                                placeholder="Enter your password"
                                className="w-full p-3 border border-gray-300 dark:border-gray-600 dark:bg-slate-700 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                disabled={loading}
                            />
                        </div>

                        {error && (
                            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 text-red-700 dark:text-red-400 px-4 py-3 rounded">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="w-full bg-blue-600 dark:bg-primaryBlue text-white py-3 rounded font-semibold hover:bg-blue-700 dark:hover:bg-primaryBlue/90 disabled:bg-gray-400 transition"
                            disabled={loading}
                        >
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BlogLoginPage;